import FullscreenOverlay from '../../../../ui/FullscreenOverlay';
import { SpokeFooterCTAs } from '../../SpokeFooterCTAs';
import { ListingHeaderActions } from '../../ListingHeaderActions';
import { HaloSpokeHeader } from '../../HaloSpokeHeader';
import { AmenitiesSpokeContent } from './AmenitiesSpokeContent';
import { footerButtonGroup, headerRight, spokeContainer } from './amenitiesSpoke.styles';

export const AmenitiesSpoke = () => {
  return (
    <div className={spokeContainer} data-testid="amenities-spoke" role="dialog" aria-label="Amenities details">
      <HaloSpokeHeader
        title="Amenities"
        actions={
          <div className={headerRight}>
            <ListingHeaderActions />
          </div>
        }
      />

      <FullscreenOverlay.Body>
        <AmenitiesSpokeContent />
      </FullscreenOverlay.Body>

      <FullscreenOverlay.Footer>
        <div className={footerButtonGroup} data-testid="amenities-spoke-footer">
          <SpokeFooterCTAs />
        </div>
      </FullscreenOverlay.Footer>
    </div>
  );
};
